<template>
  <div>
    <div class="top-bg">
      <img style="width: 100%" src="../../assets/images/detailBg.png" />
      <!--头部开始 -->
      <top-part :rightPart="true">
        <div slot="difinePort" class="top-right-box">
          <router-link class="integral-box" :to="{name:'IntegralSystem'}">积分制度</router-link>
        </div>
      </top-part>
      <!-- 头部结束 -->
      <div class="content-box">
        <div class="centent-text1">
          当前总积分
          <!-- <b>{{this.$store.state.integralAll}}</b> -->
          <b>{{inteNum}}</b>
        </div>
        <!-- tab组件开始 -->
        <div>
          <tab-list v-if="!noDate" :listAttr="listAttr" @changePage="getPage" :finishAll="finished"></tab-list>
          <!-- 暂无数据开始 -->
          <div v-if="noDate" class="content-box" style="background: #fff;">
            <div>
              <van-empty
                class="custom-image"
                :image="require('../../assets/images/null@2x.png')"
                description="暂无数据"
              />
            </div>
          </div>
          <!-- 暂无数据结束 -->
        </div>
        <!-- tab组件结束 -->
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { toast } from "@/common/api/api.js";
import topPart from "../../components/topPart";
import TabList from "./components/TabList";
import moment from "moment";
export default {
  components: {
    topPart,
    TabList
  },
  data() {
    return {
      listAttr: [], //子组件需要的分页数据
      finished: false, //通知子组件没有更多数据加载
      inteNum: "",
      noDate: false
    };
  },
  watch: {},
  mounted() {
    this.init();
    this.inteNum = JSON.parse(localStorage.getItem("integralAll"));
    // this.$route.params.integralAll
  },
  methods: {
    // 获得子组件传递的page,加载数组
    getPage(page, pageSize) {
      this.getIntegralDetail(page, pageSize);
    },
    // 获得积分明细的全部数据
    getIntegralDetail(page, pageSize) {
      let that = this;
      this.centralControl.axios.centralControl(
        "integralDetail",
        res => {
          if (res.code == 200) {
            if (res.data.length < 20) {
              that.finished = true;
            }
            if (res.data.length == 0 && that.listAttr.length == 0) {
              this.noDate = true;
              that.finished = true;
            }
            that.listAttr = [...that.listAttr, ...res.data];
            if (that.listAttr.length != 0) {
              this.listAttr.forEach(item => {
                item.createTime = moment(
                  this.centralControl.utils.obtainEast8Date(item.createTime)
                ).format("YYYY-MM-DD");
              });
            }
            console.log(res);
            console.log(that.listAttr);
          } else {
            this.noDate = true;
            that.finished = true;
            that.$message.error(res.message);
          }
        },
        { currentPage: page, pageSize: pageSize }
      );
    },
    init() {
      // this.getIntegralDetail();
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus" scoped>
@import '../../assets/stylus/index.styl';
@import '../../assets/stylus/common.styl';

.top-bg {
  // position: relative;
  // background:url(../../../assets/images/detailBg.979026a0.png) no-repeat 5px 5px;
}

.content-box {
  myContent();

  .centent-text1 {
    text-align: center;
    font-size: 14px;
    font-family: PingFang-SC-Medium, PingFang-SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;

    b {
      font-size: 26px;
      font-family: DIN-Bold, DIN;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 31px;
      vertical-align: sub;
    }
  }
}

.integral-box {
  color: #fff;
  border: 1px solid #fff;
  font-size: 14px;
  padding: 3px 10px;
  border-radius: 5px;
}

.top-box {
  background: none;
  color: #fff;
  box-shadow: none;
  background: $myGgColor;
}

.top-right-box {
  flex: 1;
  margin: auto 10px;
  text-align: right;
}
</style>